import CeleryMonitorContainer from "./CeleryMonitorContainer";

export default CeleryMonitorContainer;
